import { Card, CardBody } from "@material-tailwind/react";
import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const ProfileData = () => {
  const [userData, setUserData] = useState({});
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleUsername = (e) => {
    setUsername(e.target.value);
  };

  const handleName = (e) => {
    setName(e.target.value);
  };

  const handleAddress = (e) => {
    setAddress(e.target.value);
  };

  const handleContact = (e) => {
    setContact(e.target.value);
  };

  const handleEmail = (e) => {
    setUsername(e.target.value);
  };

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const storedId = localStorage.getItem("id");

    if (token && storedId) {
      axios
        .get(`https://erp.digitalindustryagency.com/api/users/${storedId}`, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const userData = response.data.data.resource;
          setUserData(userData);
          setEmail(userData.email);
          setUsername(userData.username);
          setName(userData.name);
          setContact(userData.contact);
          setAddress(userData.address);
        })
        .catch((error) => {
          console.error("Error fetching user data profil:", error);
        });
    }
  }, []); // useEffect will run once when the component is mounted

  const handleSave = () => {
    const token = localStorage.getItem("accessToken");
    const storedId = localStorage.getItem("id");

    const updatedData = {
      username: username,
      name: name,
      contact: contact,
      address: address,
      email: email,
    };

    axios
      .put(
        `https://erp.digitalindustryagency.com/api/users/${storedId}`,
        updatedData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.data.status) {
          console.log("Profile updated successfully:", response.data);
          setSuccessMsg(`Profile updated successfully for ${email}`);
          toast.success(`Profile updated successfully for ${email}`);
        } else {
          console.log("Profile update failed:", response.data.data.message);
          setSuccessMsg(`Profile update failed: ${response.data.data.message}`);
          toast.error(`Profile update failed: ${response.data.data.message}`);
        }
      })
      .catch((error) => {
        console.error("Error updating profile:", error);
        toast.error("Profile update failed. Please try again.");
      });
  };

  return (
    <div className="w-full lg:w-3/4 md:w-5/6 h-full flex flex-col md:gap-10">
      <h1 className="text-xl font-semibold flex">Profile</h1>
      <div className="grid gap-4 grid-cols-2">
        <div className="w-full flex-col xl:flex-row flex items-center gap-4">
          <div className="flex flex-col w-full">
            <p className="text-lg font-bodyFont font-semibold mb-6">Username</p>
            <input
              onChange={handleUsername}
              value={username}
              className="w-full h-12 border-b border-gray-400 bg-transparent px-4 text-primeColor text-lg placeholder:text-base outline-none"
              type="text"
              placeholder="Masukan Nama ...*"
            />
          </div>
        </div>
        <div>
          <div className="flex flex-col w-full">
            <p className="text-lg font-bodyFont font-semibold mb-6">Name</p>
            <input
              onChange={handleName}
              value={name}
              className="w-full h-12 border-b border-gray-400 bg-transparent px-4 text-primeColor text-lg placeholder:text-base outline-none"
              type="text"
              placeholder="Jenis Kelamin ...*"
            />
          </div>
        </div>
        <div>
          <div className="flex flex-col w-full">
            <p className="text-lg font-bodyFont font-semibold mb-6">
              No.Handphone
            </p>
            <input
              onChange={handleContact}
              value={contact}
              className="w-full h-12 border-b border-gray-400 bg-transparent px-4 text-primeColor text-lg placeholder:text-base outline-none"
              type="text"
              placeholder="087654321*"
            />
          </div>
        </div>
        <div>
          <div className="flex flex-col w-full">
            <p className="text-lg font-bodyFont font-semibold mb-6">Alamat</p>
            <input
              onChange={handleAddress}
              value={address}
              className="w-full h-12 border-b border-gray-400 bg-transparent px-4 text-primeColor text-lg placeholder:text-base outline-none"
              type="text"
              placeholder="087654321*"
            />
          </div>
        </div>
        <div>
          <div className="flex flex-col w-full">
            <p className="text-lg font-bodyFont font-semibold mb-6">Email</p>
            <input
              onChange={handleEmail}
              value={email}
              className="w-full h-12 border-b border-gray-400 bg-transparent px-4 text-primeColor text-lg placeholder:text-base outline-none"
              type="text"
              placeholder="087654321*"
            />
          </div>
        </div>
        <div>
          <button
            onClick={handleSave}
            className="rounded-md bg-primeColor cursor-pointer hover:bg-black active:bg-gray-900 px-2.5 py-2.5 font-titleFont font-semibold text-lg text-gray-200 hover:text-white duration-300"
          >
            Simpan
          </button>
          <ToastContainer position="top-right" autoClose={3000} />
        </div>
      </div>
    </div>
  );
};

export default ProfileData;
